import api from '@Services/api';
import { Import } from '@Pages/Imports/Types/Imports.types';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';
import { AxiosResponse } from 'axios';

interface ImportsCRUD extends CRUDBase<any, Import> {}
export class ImportsRequester implements ImportsCRUD {
	private static instance: ImportsRequester;
	static getInstance() {
		if (!ImportsRequester.instance) {
			ImportsRequester.instance = new ImportsRequester();
		}
		return ImportsRequester.instance;
	}
	baseURL = 'import';
	getAll(payload?: GetAllMeta): Promise<AxiosResponse<ApiResponse<Import[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<Import[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Import[]>>> {
		return await api.post(`${this.baseURL}/all`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<Import>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<Import>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Import>>>;
	async get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Import>>> {
		return await api.post(`${this.baseURL}`, { id });
	}
	create(
		payload: Omit<any, 'id'>
	): Promise<AxiosResponse<ApiResponse<Import>>> {
		throw new Error('Method not implemented.');
	}
	update(payload: any): Promise<AxiosResponse<ApiResponse<Import>>> {
		throw new Error('Method not implemented.');
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		throw new Error('Method not implemented.');
	}
}
